<template>
<MobileMenu :main-menu="context.nav.main_menu" :header-buttons="context.nav.header_buttons || []"></MobileMenu>
<SitewideHeader :context="context" :background="header"></SitewideHeader>
<div class="page-wrapper" :class="wrapperClasses">
    <slot></slot>
</div>
<SitewideFooter :class="wrapperClasses" :context="context"></SitewideFooter>
</template>

<script>
import { ref, computed, nextTick, watch, onMounted, onBeforeUnmount } from 'vue';
import { Inertia } from '@inertiajs/inertia';

import { usePage } from '@inertiajs/inertia-vue3';
import SitewideHeader from './SitewideHeader.vue';
import SitewideFooter from './SitewideFooter.vue';
import MobileMenu from './MobileMenu.vue';

const $ = window.jQuery;

export default {

    props: ['classes', 'header'],
    
    setup(props) {

        const loaded = ref(false);
        const tearDown = (e) => {
            loaded.value = false;
        };

        const smoothScrollToAnchor = (e) => {
            let target = $('#' + e.detail.id);
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 600);
        }

        onMounted(() => {
            
            Inertia.on('navigate', (event) => {
                if (event.detail.page.props.title) {
                    document.title = event.detail.page.props.title;
                }
            });

            Inertia.on('navigate', (event) => {
                if (window.hasOwnProperty('gtag')) {
                    gtag('event', 'page_view', {
                        'page_location': event.detail.page.url
                    });
                }
            });

        });

        onMounted(async () => {
            await nextTick();
            loaded.value = true;
            window.addEventListener('goingSomewhereElse', tearDown);
            window.addEventListener('clickedSmoothAnchor', smoothScrollToAnchor);
        });

        onBeforeUnmount(() => {
            window.removeEventListener('goingSomewhereElse', tearDown, false);
            window.removeEventListener('clickedSmoothAnchor', smoothScrollToAnchor, false);
        });

        const wrapperClasses = computed(() => {
            let output = props.classes.join(' ');
            if (loaded.value) {
                output = output + ' in';
            } else {
                output = output + ' shift-out';
            }
            return output;
        });

        return {
            wrapperClasses,
            context: usePage().props.value
        }

    },

    components: {
        MobileMenu,
        SitewideHeader,
        SitewideFooter
    }

}
</script>